module.exports = __webpack_public_path__ + "img/source03_m2.81bbc81b.png";